export const ANON_SOCKET_COOKIE_NAME = 'chatik_anonymous_socket_connection';
export const RESUME_SCENARIO_NOTIFICATION_LS_KEY = '__chatik_resume_creation_scenario';
export const EXPIRATION_TIME_IN_HOURS = 24;
export const COLLECT_DEBUG_DATA_DELAY_MS = 20000;
export const CHATIK_CLOSED_EVENT = 'CHATIK_CLOSED_EVENT';
